<template>
    <div id="app-layout" :class="{ 'detail success': true, 'is-edit': $route.meta.isAddView }">
        <div class="main-container">
            <div :class="{ 'main-nav': true }">
                <div
                    :class="{
                        container: true,
                        detail: true
                    }"
                >
                    <main-navigation-header></main-navigation-header>
                    <trial-over
                        @close-modal="hide_trial_modal"
                        v-if="trial_modal_shown"
                        :shown="trial_modal_shown"
                    ></trial-over>
                    <div class="main-nav-title">
                        <a @click="go_back" href="javascript:{}" class="main-nav-back">
                            <span class="icon-arrow-left"></span>
                        </a>
                        <div class="main-nav-left">
                            {{ person.first_name }} {{ person.last_name }}
                            <p>&nbsp;</p>
                            <p v-if="person.status == 'inactive'" style="margin-bottom:2rem;"></p>
                        </div>
                        <div class="main-nav-title-right" v-if="person && person.id">
                            <div
                                :class="{ 'drop menu-more': true, show: drop_shown }"
                                v-click-outside="away"
                                v-if="person.status === 'active'"
                            >
                                <a @click="show_drop" href="javascript:{}"><span class="icon icon-dots"></span></a>
                                <div class="drop-content">
                                    <ul>
                                        <li>
                                            <a @click="remove" class="red" href="javascript:{}">Remove</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div v-if="$route.meta.isAddView && person.status === 'active'">
                                <a
                                    v-if="!show_save_btn"
                                    href="javascript:{}"
                                    @click="go_to_events"
                                    :class="{
                                        disabled: events_btn_disabled,
                                        'btn btn-primary': true
                                    }"
                                >
                                    + Invite to event
                                </a>
                                <a
                                    v-else
                                    @click="save_new_person"
                                    href="javascript:{}"
                                    :class="{
                                        disabled: person_save_btn_disabled,
                                        'btn btn-primary': true
                                    }"
                                >
                                    Save
                                </a>
                            </div>
                            <div v-else>
                                <a
                                    v-show="person.status === 'active'"
                                    @click="invite"
                                    href="javascript:{}"
                                    :class="{
                                        disabled: event_ids <= 0,
                                        'btn btn-primary': true
                                    }"
                                >
                                    + Invite to selected events
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <router-view></router-view>
            <mobile-footer-menu></mobile-footer-menu>
        </div>
    </div>
</template>

<script>
import MobileFooterMenu from "./mobile-footer-menu.vue";
import MainNavigationHeader from "@/pages/main-navigation-header.vue";
import { mapActions, mapMutations, mapState } from "vuex";
import router from "@/router";
import vClickOutside from "v-click-outside";
import TrialOver from "./trial-over-modal.vue";

export default {
    name: "people-layout",
    components: { MobileFooterMenu, MainNavigationHeader, TrialOver },
    created() {},
    mounted() {
        this.get_logged_in_user();
    },
    computed: {
        ...mapState(["user"]),
        ...mapState("StorePeople", [
            "person",
            "show_save_btn",
            "event_ids",
            "person_invite_btn_disabled",
            "events_btn_disabled",
            "person_save_btn_disabled",
            "person_save_btn_loading"
        ])
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.get_logged_in_user();
            vm.previousRoute = from;
            next();
        });
    },
    data() {
        return {
            trial_modal_shown: false,
            drop_shown: false,
            previousRoute: null
        };
    },
    directives: {
        clickOutside: vClickOutside.directive
    },
    methods: {
        ...mapActions("StorePeople", ["save_person", "delete_person", "invite_to_events"]),
        ...mapMutations("StorePeople", ["set_save_btn_state"]),
        ...mapActions(["get_logged_in_user"]),

        away() {
            if (this.drop_shown) {
                this.drop_shown = false;
            }
        },
        hide_trial_modal() {
            this.trial_modal_shown = false;
        },
        save_new_person() {
            if (this.user && this.user.active_plan && this.user.active_plan.id) {
                let person = { ...this.person };
                this.save_person(person);
                this.set_save_btn_state(false);
            } else {
                this.trial_modal_shown = true;
            }
        },
        remove() {
            if (this.user && this.user.active_plan && this.user.active_plan.id) {
                if (confirm("Are you sure?")) {
                    if (this.person.id) {
                        this.delete_person(this.person.id);
                    }
                }
            } else {
                this.drop_shown = false;
                this.trial_modal_shown = true;
            }
        },
        go_to_events() {
            if (this.person.id) {
                router.push({ path: "/people/" + this.person.id + "/events" });
            }
        },
        invite() {
            if (this.user && this.user.active_plan && this.user.active_plan.id) {
                this.invite_to_events(this.person.id);
            } else {
                this.trial_modal_shown = true;
            }
        },
        go_back() {
            if (this.$route.name === "person-events") {
                router.push({ path: "/people/" + this.person.id });
            } else if (
                this.$route.name === "person-edit" &&
                this.previousRoute &&
                this.previousRoute.name === "event-guests"
            ) {
                router.push({ path: this.previousRoute.path });
            } else {
                router.push({ path: "/people" });
            }
        },
        show_drop() {
            this.drop_shown = !this.drop_shown;
        }
    }
};
</script>

<style scoped>
.drop {
    flex: initial;
    width: initial;
    margin-left: auto;
    margin-bottom: 18px;
}

.main-nav-title-right {
    display: flex;
    flex-direction: column;
    margin-bottom: 2rem;
}

.main-nav-title {
    position: relative;
}
</style>
